module.exports = __webpack_public_path__ + "media/base/bell-325b2884.svg";